const matahariQuiz = [
  {
    question: "Matahari adalah apa dalam tata surya?",
    options: ["Planet", "Bulan", "Bintang", "Asteroid"],
    answer: 2,
  },
  {
    question: "Peran utama Matahari dalam tata surya adalah?",
    options: [
      "Mengelilingi planet",
      "Memberi cahaya dan panas",
      "Menjadi satelit Bumi",
      "Mengatur cuaca",
    ],
    answer: 1,
  },
  {
    question: "Mengapa Matahari sangat penting bagi kehidupan di Bumi?",
    options: [
      "Karena ukurannya besar",
      "Karena warnanya terang",
      "Karena memberikan energi",
      "Karena dekat dengan Bumi",
    ],
    answer: 2,
  },
  {
    question: "Sumber energi utama Matahari berasal dari?",
    options: [
      "Api",
      "Listrik",
      "Reaksi nuklir",
      "Gesekan gas",
    ],
    answer: 2,
  },
  {
    question: "Cahaya Matahari membutuhkan waktu sekitar berapa menit untuk sampai ke Bumi?",
    options: ["1 menit", "4 menit", "8 menit", "15 menit"],
    answer: 2,
  },
  {
    question: "Lapisan terluar Matahari yang terlihat saat gerhana disebut?",
    options: [
      "Inti",
      "Fotosfer",
      "Korona",
      "Mantel",
    ],
    answer: 2,
  },
  {
    question: "Gerakan planet mengelilingi Matahari disebabkan oleh?",
    options: [
      "Panas Matahari",
      "Cahaya Matahari",
      "Gravitasi Matahari",
      "Angin surya",
    ],
    answer: 2,
  },
  {
    question: "Matahari terbentuk terutama dari gas?",
    options: [
      "Oksigen dan nitrogen",
      "Karbon dan helium",
      "Hidrogen dan helium",
      "Uap air dan udara",
    ],
    answer: 2,
  },
  {
    question: "Apa yang akan terjadi jika Matahari tidak ada?",
    options: [
      "Bumi tetap hangat",
      "Tidak ada siang dan malam",
      "Kehidupan di Bumi tidak bisa bertahan",
      "Bulan akan hilang",
    ],
    answer: 2,
  },
  {
    question: "Matahari berusia sekitar?",
    options: [
      "1 juta tahun",
      "100 juta tahun",
      "4,6 miliar tahun",
      "10 miliar tahun",
    ],
    answer: 2,
  },
];

export default matahariQuiz;
